import connectToStores from "alt-utils/lib/connectToStores";
import PropTypes from "prop-types";
import React, { Component } from "react";

import AskFormStore from "../../../stores/chat/AskFormStore";
import AskQuestionFormContactInfoInput from "../AskQuestionFormContactInfoInput";
import ChatActions from "../../../actions/ChatActions";
import ConfigStore from "../../../stores/chat/ConfigStore";

export class ContactInfoPromptSystemMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formWasSubmitted: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    static getPropsFromStores() {
        return {
            chatConfigId: ConfigStore.getConfig().id,
            contactInfo: AskFormStore.getState().contactInfo,
            isProcessing: AskFormStore.getState().isProcessing,
            isValid: AskFormStore.isContactInfoValid(),
        };
    }

    static getStores() {
        return [AskFormStore, ConfigStore];
    }

    onSubmit(event) {
        this.setState(
            () => ({
                formWasSubmitted: true,
            }),
            () => {
                if (this.props.isValid) {
                    ChatActions.updateContact({
                        chatConfigId: this.props.chatConfigId,
                        chatId: this.props.questionUuid,
                        contact: this.props.contactInfo,
                    });
                }
            }
        );
        event.preventDefault();
    }

    render() {
        const { allowQuestionSignupWithPhoneNumber } = window.companySettings;
        const { isProcessing } = this.props;

        return (
            <li className="system-message contact-prompt">
                <form noValidate onSubmit={this.onSubmit}>
                    <AskQuestionFormContactInfoInput
                        allowQuestionSignupWithPhoneNumber={allowQuestionSignupWithPhoneNumber}
                        askFormHeight="30"
                        label={i18n.t("rtm.text.contact_info_prompt_system_message")}
                        disabled={isProcessing}
                        shouldDisplayError={this.state.formWasSubmitted}
                    />
                    <button className="btn btn-full-width" disabled={isProcessing} type="submit">
                        {i18n.t("rtm.button.confirm")}
                    </button>
                </form>
            </li>
        );
    }
}

ContactInfoPromptSystemMessage.propTypes = {
    chatConfigId: PropTypes.string.isRequired,
    contactInfo: PropTypes.string.isRequired,
    isProcessing: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    questionUuid: PropTypes.string.isRequired,
};

export default connectToStores(ContactInfoPromptSystemMessage);
